import { Link as TanStackLink } from "@tanstack/react-router";
import type { AnchorHTMLAttributes } from "react";

type RouterLinkProps = Omit<AnchorHTMLAttributes<HTMLAnchorElement>, "href"> & {
  to: string;
};

export function Link({ to, ...props }: RouterLinkProps) {
  if (
    to === "#" ||
    to.startsWith("#") ||
    to.startsWith("tel:") ||
    to.startsWith("mailto:") ||
    to.startsWith("http://") ||
    to.startsWith("https://")
  ) {
    return <a href={to} {...props} />;
  }

  const normalizedTo =
    to !== "/" && to.startsWith("/") && !to.endsWith("/") && !to.includes(".")
      ? `${to}/`
      : to;

  return <TanStackLink to={normalizedTo as never} {...props} />;
}
